// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppsBusinessAccountFieldsResult = objectOf({
  account_fields: arrayOf(
    objectOf({
      name: string,
      token: string,
      type: string,
    })
  ),
});
